import { isJsonString } from 'utils/helpers';
import { CookieStorage } from '../../utils/cookie-storage';
import { StorageKeys } from '../../constants/storage-keys';
import { checkAccessScreen } from 'utils/url';

/**
 *
 * WithAuthorization
 *
 */
function AuthorizationWrapper({
  children,
  allowedRoles,
  disabled = false,
  groupPermission,
  groupName,
}) {
  const user = CookieStorage.getCookieData(StorageKeys.UserInfo);

  const userRole = user?.role;
  const hasRole = userRole ? (allowedRoles || []).some(role => userRole.includes(role)) : false;
  // const isAccess = checkAccessScreen({ userRoles, groupName, groupPermission });

  if (hasRole) {
    return children;
  } else {
    return null;
  }
  // if (user?.level === '1' || (hasRole && isAccess) || (!allowedRoles && !userRoles.length)) {
  //   return children;
  // } else {
  //   if (disabled) {
  //     return children;
  //   }
  //   return null;
  // }
}

export default AuthorizationWrapper;
